var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-147 -70 294 345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a4c639"
  }, /*#__PURE__*/React.createElement("use", {
    strokeWidth: 14.4,
    xlinkHref: "#b",
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a",
    stroke: "#FFF",
    strokeWidth: 7.2
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 6.5,
    transform: "rotate(29)",
    height: 86,
    width: 13,
    y: -86,
    x: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    rx: 24,
    height: 133,
    width: 48,
    y: 41,
    x: -143
  }), /*#__PURE__*/React.createElement("use", {
    y: 97,
    x: 85,
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cy: 41,
    rx: 91,
    ry: 84
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 22,
    height: 182,
    width: 182,
    y: 20,
    x: -91
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 7.2,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-95 44.5h190"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -42,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidLogo);
export default __webpack_public_path__ + "static/media/Android_Logo.01ffa90502abf5e47fec750c5b92be28.svg";
export { ForwardRef as ReactComponent };